import React, { Component } from 'react';
import './App.css';
import {
  createMuiTheme,
  MuiThemeProvider,
  withStyles,
} from '@material-ui/core/styles';
import { isMobile } from 'react-device-detect';
import { debounce } from 'throttle-debounce';
import FilterBar from './FilterBar.js';
import ListingsGrid from '../components/ListingsGrid.js';
import MobileSearch from './MobileSearch';
import { withinBounds } from '../components/mapHelper';


const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#ff8e8c',
      main: '#484848',
      dark: '#7E1541',
      contrastText: '#fff',
    },
    secondary: {
      light: '#008489',
      main: '#ff5a5f',
      dark: '#004e5a',
      contrastText: '#000',
    },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: 14,
    textTransform: 'none',
    color: '#484848',
    button: {
      textTransform: 'none',
    },
    subtitle1: {
      fontWeight: 600,
      color: '#484848',
      fontSize: 14,
    },
    h6: {
      fontSize: 16,
      fontWeight: 600,
      color: '#484848',
    },
  },
});

const styles = {
  planeIcon: {
    color: '#F44436',
    marginTop: 15,
    marginRight: 15,
    fontSize: 35,
  },
  mapDiv: {
    height: '82vh',
    width: '70%',
    display: 'inline-block',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  superParentDiv: {
    // padding: '0px 0px 0px 30px',
    [theme.breakpoints.down('sm')]: {
      padding: '0px',
    },
  },
};

const initialFilterState = {
        status: ['ACT']
    };



class App extends Component {
  constructor(props) {
    super(props);
    const initialFilter = window.location.search && window.location.search.length > 0
      ? this.getQueryVariable(window.location.search)
      : {};

    if (!initialFilter.status) {
      initialFilter.status = ['ACT'];
    }
    if (initialFilter.searchStr) {
      initialFilter.searchStr = decodeURIComponent(initialFilter.searchStr.replace(/\+/g, '%20'));
    }

    this.state = {
      listings: [],
      listingFilter: initialFilter || {},
      mapShowing: true,
      isLoading: true,
      advancedSearchCollapsed: false,
      searchId:1
    };

    this.filterChanged = this.filterChanged.bind(this);
    this.toggleAdvancedSearch = this.toggleAdvancedSearch.bind(this);
    this.fetchListingsDebounced = debounce(500, this.filterChanged);
    this.getQueryVariable = this.getQueryVariable.bind(this);

  }

  componentDidMount() {
    // const initialFilter = this.getInitialFilter();
    this.fetchListings(this.state.listingFilter).then(() => {

    });
  }

  getInitialFilter = () => {
    const pairs = window.location.search.slice(1).split('&');

    const result = {};
    pairs.forEach((p) => {
      const pair = p.split('=');
      const key = pair[0];
      const value = decodeURIComponent(pair[1] || '');

      if (result[key]) {
        if (Object.prototype.toString.call(result[key]) === '[object Array]') {
          result[key].push(value);
        } else {
          result[key] = [result[key], value];
        }
      } else {
        result[key] = key === 'status' && !!value ? value.split(',') : value;
      }
    });

    return JSON.parse(JSON.stringify(result));
  };

  toggleAdvancedSearch = () => {
    this.setState((prevState) => ({
      advancedSearchCollapsed: !prevState.advancedSearchCollapsed,
    }));
  };

  getQueryVariable = (queryString) => {
    const query = {};
    const pairs = (queryString[0] === '?'
      ? queryString.substr(1)
      : queryString
    ).split('&');

    pairs.forEach((p) => {
      const pair = p.split('=');
      const key = decodeURIComponent(pair[0]);
      const value = decodeURIComponent(pair[1] || '');

      if (query[key]) {
        if (Object.prototype.toString.call(query[key]) === '[object Array]') {
          query[key].push(value);
        } else {
          query[key] = [query[key], value];
        }
      } else {
          query[key] = key === 'status' && !!value ? value.split(',') : value;
      }
    });
    return query;
  };

  convertToQueryString = (obj, prefix) => {
    const str = [];
    let p = '';
    for (p in obj) {
      const k = prefix ? `${prefix}[${p}]` : p;
      const v = obj[p];

      str.push(
        v !== null && typeof v === 'object' && !Array.isArray(v)
          ? this.convertToQueryString(v, k)
          : `${k}=${v}`
      );
    }
    return str.join('&');
  };

  getShortPrice = (num) => {
    const si = [
      { value: 1, symbol: '' },
      { value: 1E3, symbol: 'K' },
      { value: 1E6, symbol: 'M' },
      { value: 1E9, symbol: 'G' },
      { value: 1E12, symbol: 'T' },
      { value: 1E15, symbol: 'P' },
      { value: 1E18, symbol: 'E' }
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    let i;
    // eslint-disable-next-line no-plusplus
    for (i = si.length - 1; i > 0; i--) {
      if (num >= si[i].value) {
        break;
      }
    }
    const numAsStr = (num / si[i].value).toString().replace(rx, '$1');
    let shortPrice = numAsStr.substring(0, 3);
    if (shortPrice.indexOf('.') > 0) {
      shortPrice = numAsStr.substring(0, 4);
    }
    return shortPrice + si[i].symbol;
  };


  fetchListings = async (listingFilter) => {
    const queryString = this.convertToQueryString(listingFilter);

    const url = window.location.href.includes('localhost:3000')
      ? `http://localhost:5000/listings/search2?${queryString}`
      : `/listings/search2?${queryString}`;
    this.setState({ isLoading: true, listingFilter });

    // this.setState({ 'mapCoordinatesK'} );

    await fetch(url)
      .then((response) => response.json())
      .then((listings) => {
        listings.forEach((listing) => {
          listing.shortPrice = this.getShortPrice(listing.price);
        });
        this.setState({ listings, isLoading: false });
      })
      .catch((reason) => {
        //  console.log(reason);
      });
  };

  filterChanged = (filterChange, preventRefresh) => {
    const listingFilter = { ...this.state.listingFilter, ...filterChange };
    if (preventRefresh) {
      this.setState({ isLoading: false, listingFilter });
    }
    if (!preventRefresh) {
      this.fetchListings(listingFilter).then(() => {
        this.setState({ isLoading: false });
      });
    }
  };

  clearFilter = () => {

    this.fetchListings(initialFilterState).then(() => {

      const searchId = this.state.searchId + 1;
      this.setState({
        isLoading: false,
        listingFilter: initialFilterState,
        advancedSearchCollapsed:false,
        searchId: searchId
      });
    });
  };

  handleChange = (val, field) => {
    const { listingFilter } = this.state;
    const obj = {};
    obj[field] = val;
    const newValue = { ...listingFilter, ...obj };
    // const newValue = { ...listingFilter, obj };
    console.log(newValue);
    this.setState({ listingFilter: newValue });
  };

  handleSearch = (e) => {
    this.fetchListingsDebounced({ searchStr: e.target.value });
  };

  toggleMapShowing = () => {
    this.setState((prevState) => ({ mapShowing: !prevState.mapShowing }));
  };

  render() {
    const {
      mapShowing,
      filterValue,
      listings,
      listingFilter,
      isLoading,
      advancedSearchCollapsed,
      searchId
    } = this.state;

    const memphisListings = listings.filter((x) => x.geoCode && withinBounds(x.geoCode));
    return (
      <MuiThemeProvider theme={theme}>
        {!isMobile && (
          <div className="d-none d-md-block">
            <div>
              <FilterBar
                // years={this.state.years}
                toggleChipProperty={this.toggleChipProperty}
                clearAllChips={this.clearAllChips}
                selectAllChips={this.selectAllChips}
                toggleMapShowing={this.toggleMapShowing}
                mapShowing={mapShowing}
                handleChange={this.handleChange}
                handleSearch={this.handleSearch}
                updateFilter={this.filterChanged}
                toggleAdvancedSearch={this.toggleAdvancedSearch}
                advancedSearchCollapsed={advancedSearchCollapsed}
                filterValue={filterValue}
                listingFilter={listingFilter}
                clearFilter={this.clearFilter}
                searchId={searchId}
              />
            </div>
            <ListingsGrid
              updateFilter={this.filterChanged}
              listings={listings}
              listingFilter={listingFilter}
              mapShowing={mapShowing}
              toggleMapShowing = {
                this.toggleMapShowing
              }
              isLoading={isLoading}
            />
          </div>
        )}
        {isMobile && (
          <div className="d-sm-block">
            <MobileSearch
              toggleMapShowing={this.toggleMapShowing}
              mapShowing={!mapShowing}
              handleSearch={this.handleSearch}
              updateFilter={this.filterChanged}
              clearFilter={this.clearFilter}
              listingFilter={listingFilter}
              listings={listings}
              handleChange={this.handleChange}
              handleSearch={this.handleSearch}
              isLoading={isLoading}
              searchId={searchId}
            />
          </div>
        )}
      </MuiThemeProvider>
    );
  }
}

export default withStyles(styles)(App);
